(function () {
  function moveModalToBody(modal) {
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
  }

  function moveToastToBody(toast) {
    if (toast && toast.parentElement !== document.body) {
      document.body.appendChild(toast);
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.writeReviewReady === 'true') return;

    var shopDomain = root.dataset.shopDomain;
    var productId = root.dataset.productId;
    var productHandle = root.dataset.productHandle || '';

    var modal = root.querySelector('[data-shop-write-review-modal]');
    var form = root.querySelector('[data-shop-write-review-form]');
    var successPanel = root.querySelector('[data-shop-write-review-success]');
    var successText = root.querySelector('[data-shop-write-review-success-text]');
    var toast = root.querySelector('[data-shop-write-review-toast]');
    var toastText = root.querySelector('[data-shop-write-review-toast-text]');
    var statusEl = root.querySelector('[data-shop-write-review-status]');
    var ratingInput = root.querySelector('[data-shop-write-review-rating]');
    var starButtons = root.querySelectorAll('[data-shop-write-review-star]');

    if (!modal || !form || !shopDomain || !productId) return;

    root.dataset.writeReviewReady = 'true';
    moveModalToBody(modal);
    moveToastToBody(toast);

    var selectedRating = 0;
    var toastTimer = null;
    var successTimer = null;

    function setStatus(message, type) {
      if (!statusEl) return;
      statusEl.textContent = message || '';
      if (message) {
        statusEl.removeAttribute('hidden');
      } else {
        statusEl.setAttribute('hidden', '');
      }
      statusEl.dataset.state = type || '';
    }

    function setRating(value) {
      selectedRating = value;
      if (ratingInput) ratingInput.value = String(value);
      starButtons.forEach(function (btn) {
        var starValue = parseInt(btn.getAttribute('data-shop-write-review-star') || '0', 10);
        btn.setAttribute('aria-pressed', starValue <= value ? 'true' : 'false');
        btn.classList.toggle('is-active', starValue <= value);
      });
    }

    function resetModalView() {
      if (form) form.hidden = false;
      if (successPanel) successPanel.hidden = true;
      setStatus('');
      form.reset();
      setRating(0);
    }

    function openModal() {
      moveModalToBody(modal);
      resetModalView();
      modal.removeAttribute('hidden');
      document.body.classList.add('shop-write-review-modal-open');
      var firstField = form.querySelector('input, textarea');
      if (firstField) firstField.focus();
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.classList.remove('shop-write-review-modal-open');
      if (successTimer) {
        window.clearTimeout(successTimer);
        successTimer = null;
      }
      resetModalView();
    }

    function showToast(message) {
      if (!toast) return;
      moveToastToBody(toast);
      if (toastText && message) toastText.textContent = message;
      toast.removeAttribute('hidden');
      toast.classList.add('is-visible');
      if (toastTimer) window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () {
        hideToast();
      }, 6000);
    }

    function hideToast() {
      if (!toast) return;
      toast.classList.remove('is-visible');
      toast.setAttribute('hidden', '');
      if (toastTimer) {
        window.clearTimeout(toastTimer);
        toastTimer = null;
      }
    }

    function showSuccess(message) {
      var copy = message || 'Your review was submitted and will appear here shortly.';
      if (successText) successText.textContent = copy;
      form.hidden = true;
      successPanel.removeAttribute('hidden');
      successTimer = window.setTimeout(function () {
        closeModal();
        showToast(copy);
        window.dispatchEvent(new CustomEvent('shop-reviews:reload'));
      }, 2200);
    }

    function isWriteReviewTrigger(node) {
      return node && node.closest('[data-shop-write-review-open]');
    }

    root.addEventListener(
      'click',
      function (event) {
        if (isWriteReviewTrigger(event.target)) {
          event.preventDefault();
          event.stopPropagation();
          openModal();
        }
      },
      true
    );

    modal.querySelectorAll('[data-shop-write-review-close]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    });

    if (toast) {
      toast.querySelectorAll('[data-shop-write-review-toast-close]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          hideToast();
        });
      });
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal.querySelector('[data-shop-write-review-backdrop]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });

    starButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setRating(parseInt(btn.getAttribute('data-shop-write-review-star') || '0', 10));
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      setStatus('');

      var formData = new FormData(form);
      var name = String(formData.get('name') || '').trim();
      var email = String(formData.get('email') || '').trim();
      var reviewerDetails = String(formData.get('reviewer_details') || '').trim();
      var body = String(formData.get('body') || '').trim();

      if (!selectedRating) {
        setStatus('Please choose a star rating.', 'error');
        return;
      }
      if (!name || !email || !reviewerDetails || !body) {
        setStatus('Please fill in your name, email, reviewer details, and review.', 'error');
        return;
      }

      var payload = new FormData();
      payload.append('shop_domain', shopDomain);
      payload.append('platform', 'shopify');
      payload.append('id', productId);
      payload.append('name', name);
      payload.append('email', email);
      payload.append('rating', String(selectedRating));
      payload.append('body', body);
      payload.append('title', reviewerDetails);

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      setStatus('Submitting your review…', 'pending');

      fetch('https://judge.me/api/v1/reviews', {
        method: 'POST',
        body: payload,
        mode: 'cors'
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              throw new Error((data && (data.message || data.error)) || 'Could not submit review.');
            }
            return data;
          });
        })
        .then(function (data) {
          var message = (data && data.message) || 'Your review was submitted and will appear here shortly.';
          showSuccess(message);
        })
        .catch(function (error) {
          var fallbackUrl = productHandle ? '/products/' + productHandle + '#judgeme_product_reviews' : '';
          if (fallbackUrl) {
            setStatus(
              (error && error.message ? error.message + ' ' : '') +
                'You can also leave a review on the product page.',
              'error'
            );
          } else {
            setStatus((error && error.message) || 'Could not submit review. Please try again.', 'error');
          }
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-shop-write-review-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
})();
